export const CONSOLE_SITE_URL = 'https://console.mlt-med.com';
export const MEETING_SITE_URL = 'https://meeting.mlt-med.com';
export const MEETING_DOWNLOAD_URL = 'https://meeting.mlt-med.com/download'